export interface AccessSetting {
    accessType: AccessType;
    icon: string;
}

export interface UserAccess {
    roleId: string;
    accessLevel: AccessType
}

export enum AccessType {
    NoAccess = 'prohibited',
    View = 'view',
    Edit = 'edit',
    Owner = 'owner'
}

export enum PageAccessType {
    Public = 'public',
    Private = 'private',
}

export enum TrendGraphAccessEvents {
    TrendGraphAccessUpdated = 'trendGraphAccessUpdated',
}

export enum CustomGroupAccessEvents {
    CustomGroupAccessUpdated = 'customGroupAccessUpdated',
}

export enum CustomGraphAccessEvents {
    CustomGraphAccessUpdated = 'customGraphAccessUpdated',
}